import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { cn } from "@roman/shared/utils";

interface ProgressProps extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  trackColor?: string;
  indicatorColor?: string;
  tiltGap?: boolean;
}

const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, ProgressProps>(
  (
    { className, value, trackColor = "bg-[#FF5A37]", indicatorColor = "bg-[#00AAA1]", tiltGap = false, ...props },
    ref,
  ) => {
    const yesPercent = value || 0;
    const gapWidth = 1.33;
    return (
      <ProgressPrimitive.Root
        ref={ref}
        className={cn("relative w-full h-[6.54px] overflow-hidden", trackColor, className)}
        {...props}
      >
        {/* YES (left) bar */}
        <ProgressPrimitive.Indicator
          className={cn(
            "absolute left-0 top-0 h-full transition-all",
            yesPercent !== 100 && yesPercent !== 0 ? "border-r-2 border-r-white" : "",
            indicatorColor,
          )}
          style={{
            width: yesPercent === 100 ? "100%" : `calc(${yesPercent}% - ${gapWidth / 2}px)`,
            borderRadius: 0,
            zIndex: 2,
            ...(tiltGap &&
              yesPercent !== 100 &&
              yesPercent !== 0 && {
                transform: "skewX(-15deg)",
              }),
          }}
        />
        {/* White gap */}
        {yesPercent !== 100 && yesPercent !== 0 && (
          <div
            className="absolute top-0"
            style={{
              left: `calc(${yesPercent}% - ${gapWidth / 2}px)`,
              height: "100%",
              background: "white",
              zIndex: 3,
              ...(tiltGap && {
                transform: "skewX(-15deg)",
                transformOrigin: "center",
              }),
            }}
          />
        )}

        <div
          className="absolute top-0 left-0 h-full bg-[#00AAA1]"
          style={{
            width: yesPercent === 100 ? "100%" : `calc(${yesPercent}% - ${gapWidth / 2}px)`,
            clipPath: "polygon(0 0, 100% 0, 30% 100%, 0 100%)",
          }}
        />
      </ProgressPrimitive.Root>
    );
  },
);

Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
